<template>
    <div class="plansModInfoMainWrap plan-info-wrapper">
        <vx-card class="plansModInfoWrap">
            <div v-if="productsFound" slot="no-body">

                <!-- Toggles  -->
                <div class="plansTabsWrap adaaadadaddaaddad">

                    <!-- logo and toggles -->
                    <vs-row class="justify-between">
                        <vs-col vs-lg="4" vs-sm="6" vs-xs="4">
                            <div class="">
                                <img src="@/assets/images/logo/ilerno-logo.svg" width="100px" alt="ILERNO Logo" class="" />
                            </div>
                        </vs-col>
                        <vs-col vs-lg="4" vs-sm="6" vs-xs="8" class="flex flex-col gap-3 justify-center items-end">
                            <!-- Currency Toggle -->
                            <div class="radioSwitchMainWrap">
                                <div class="orientationWrapper p-0 m-0">
                                    <div class="radioSwitchWrap m-0">
                                        <input type="radio" id="currencyUSD" value="USD" v-model="priceCurrencyCode" hidden>
                                        <label for="currencyUSD">USD</label>
                                        <input type="radio" id="currencyGBP" value="GBP" v-model="priceCurrencyCode" hidden>
                                        <label for="currencyGBP">GBP</label>
                                    </div>
                                </div>
                            </div>

                            <!-- Period Toggle -->
                            <div class="radioSwitchMainWrap">
                                <div class="orientationWrapper p-0 m-0">
                                    <div class="radioSwitchWrap m-0">
                                        <!-- annuallyBilledTab -->
                                        <input type="radio" id="orientationAnnually" value="Annually" v-model="billingCycleRadio" hidden>
                                        <label for="orientationAnnually">{{ $t("Annually Billed") }}</label>
                                        <!-- monthlyBilledTab -->
                                        <input type="radio" id="orientationMonthly" value="Monthly" v-model="billingCycleRadio" hidden>
                                        <label for="orientationMonthly">{{ $t("Monthly Billed") }}</label>
                                        <!-- lifeTimeBilledTab -->
                                        <input type="radio" id="orientationLifeTime" value="LifeTime" v-model="billingCycleRadio" hidden>
                                        <label for="orientationLifeTime">{{ $t("Lifetime") }}</label>
                                    </div>
                                </div>
                            </div>
                        </vs-col>
                    </vs-row>

                    <!-- products loop  -->
                    <vs-row class="flex flex-wrap justify-center vnx-row">
                        <vs-col v-for="(product, index) in visibleProducts" :key="index"  vs-lg="3" vs-sm="6" vs-xs="12" class="vx-col currentPlansCol">
                            <div class="signup-select-plan">
                                <div class="plan-card">
                                    <div class="flex justify-center plans_image_wrap">
                                        <img
                                            class="plans_image"
                                            :src="product.image_url"
                                            :alt="product.name" />
                                    </div>
                                    <div class="text-center">
                                      <h5 class="heading-title">{{ product.name }}</h5>
                                      <p class="product_description">{{ product.description }}</p>
                                    </div>
                                    <vs-divider></vs-divider>

                                    <!-- monthly & annually core pricing loop  -->
                                    <div v-for="price in filteredPrices(product)" :key="price.id" class="right_holder text-center">
                                        <RecurringCorePrices :price="price" :monthlyBilledTab="monthlyBilledTab"/>
                                    </div>

                                </div>

                                <!-- BUTTON SECTION -->
                                <!-- price loop on type === core
                                    buy button for annuall & monthly subscription -->
                                <div v-for="price in product.prices" :key="price.id" class="right_holder text-center">

                                    <!-- Billing Cycle Plans -->
                                    <div class="m-0"
                                        v-if="
                                                price.custom_data &&
                                                price.custom_data.type === 'core' &&
                                                price.billing_cycle &&
                                                ((monthlyBilledTab && price.billing_cycle.interval === 'month') ||
                                                (!monthlyBilledTab && price.billing_cycle.interval === 'year'))"
                                        >

                                        <!-- Purchase buttons -->
                                        <template v-if="product.custom_data.multiPrice && product.custom_data.multiPrice == 1">
                                            <template v-if="price.unit_price.currency_code === priceCurrencyCode">
                                                <vs-button
                                                    type="border"
                                                    class="flex flex-wrap m-auto btn-size-sm"
                                                    @click="buyPaddleProduct(price, product)">Go {{ product.name }}
                                                </vs-button>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <vs-button
                                                type="border"
                                                class="flex flex-wrap m-auto btn-size-sm"
                                                @click="buyPaddleProduct(price, product)">Go {{ product.name }}
                                            </vs-button>
                                        </template>

                                    </div>

                                    <!-- One Time Plans -->
                                    <div v-if="price.billing_cycle == null">
                                        <div v-if="price.unit_price.currency_code == priceCurrencyCode">
                                            <vs-button
                                                type="border"
                                                class="flex flex-wrap m-auto btn-size-sm"
                                                @click="buyPaddleProduct(price, product)">Go {{ product.name }}
                                            </vs-button>
                                        </div>
                                    </div>
                                </div>

                                <!-- add-ons -->
                                <ProductAddons :product="product"
                                                :monthlyBilledTab="monthlyBilledTab"
                                                :priceCurrencyCode="priceCurrencyCode"
                                />

                            </div>
                        </vs-col>
                    </vs-row>
                </div>
            </div>
            <div v-else>
                <p>No record found</p>
            </div>
        </vx-card>

        <plansFooter></plansFooter>

    </div>
</template>

<script>
import { paddleMixin } from '@/mixins/paddle/paddle.js'
import { ToggleButton } from 'vue-js-toggle-button'
import {EventBus} from '@/mixins/EventBus'
import PriceCaptions from '@/views/pages/PaddlePlans/PriceCaptions.vue'
import ProductAddons from '@/views/pages/PaddlePlans/ProductAddons.vue'
import RecurringCorePrices from '@/views/pages/PaddlePlans/RecurringCorePrices.vue'
import plansFooter from '@/views/pages/v1/signup/plansFooter.vue'

export default {
    mixins: [ EventBus,
            paddleMixin,
    ],
    components:{
        ToggleButton,
        PriceCaptions,
        RecurringCorePrices,
        ProductAddons,
        plansFooter,
    },
    data() {
        return {
            plansParams: null,
            billingCycleRadio: "Annually",
            monthlyBilledTab: false,
            annuallyBilledTab: true, // by default
            lifeTimeTab: false,

            priceCurrencyCode: 'USD',
            all_paddle_products: [],
            productsFound : false,
        }
    },
    computed: {
        visibleProducts() {
            const products = this.visiblePaddleProducts();

            if (this.lifeTimeTab) {
                return products.filter(p => !this.isSubscriptionPricePlan(p.prices[0]));
            }

            if (this.monthlyBilledTab || this.annuallyBilledTab) {
                return products.filter(p => this.isSubscriptionPricePlan(p.prices[0]));
            }

            return [];
        },
    },
    watch : {
        billingCycleRadio(value)
        {
            console.log('billingCycleRadio: ', value)
            if (value == 'LifeTime') {
                this.lifeTimeTab = true

                this.monthlyBilledTab = false
                this.annuallyBilledTab = false
            }
            else if (value == 'Monthly') {
                this.monthlyBilledTab = true

                this.lifeTimeTab = false
                this.annuallyBilledTab = false
            }
            else if (value == 'Annually') {
                this.annuallyBilledTab = true

                this.lifeTimeTab = false
                this.monthlyBilledTab = false
            }
        }
    },
    async created() {
        // get plans from params
        this.plansParams = this.$route.params.plansParams
        console.log('plansParams', this.plansParams)

        this.all_paddle_products = this.plansParams
        this.productsFound = true

        this.checkMultipleCurrencyProduct()

        // this.getStarted()
    },
    mounted () {

    },
    methods:{
        isSubscriptionPricePlan(price) {

            const priceToCheck = price

            // Subscription Plan Case
            if (priceToCheck.billing_cycle != null &&
                !this.zeroAmountPrice(priceToCheck.unit_price.amount)
            ) {
                return true;
            }
            // Free Plan Case
            else if (priceToCheck.billing_cycle != null &&
                this.zeroAmountPrice(priceToCheck.unit_price.amount)
            ) {
                return false;
            }
            // Non-Subscription Case
            else {
                return false;
            }
        },
        // Shared base list
        visiblePaddleProducts() {
            return (this.all_paddle_products).filter(
                p => p.custom_data.visible == '1'
            );
        },
        checkMultipleCurrencyProduct()
        {
            this.all_paddle_products.forEach(product => {
                console.log('product.custom_data.multiPrice: ', product.custom_data.multiPrice)
            });
        },
        filteredPrices(product) {
            if (product.custom_data &&
                product.custom_data.multiPrice &&
                product.custom_data.multiPrice == 1)
            {
                return product.prices.filter(
                    price => price.unit_price.currency_code === this.priceCurrencyCode
                );
            }
            return product.prices;
        },
        async getStarted() {
            try
            {
                this.$vs.loading({
                    text: 'Loading, Please wait...'
                })

                // get all products & customer subscription object
                const response = await Promise.all([this.getActivePaddleProducts()])
                console.log('response', response)

                if(typeof response[0] !== "undefined") {
                    console.log('response[0]: ', response[0])
                    this.all_paddle_products = response[0].data.data
                    this.productsFound = true
                }
                this.$vs.loading.close()
            } catch (error) {
                this.productsFound = false
                console.log('created error', error)
                this.$vs.loading.close()
            }
        },
        toggleBillingCycle(newValue) {
            console.log('toggleBillingCycle: ', newValue)
            if (newValue.value) {
                this.monthlyBilledTab = true
            } else {
                this.monthlyBilledTab = false
            }
        },
        filterTotalCustomData(product) {
            return this.monthlyBilledTab ? product.totalCustomData.month : product.totalCustomData.year;
        },
        getTextForKey(key, value) {
            if (this.monthlyBilledTab) {
                switch (key) {
                    case 'totalLimitStaffMonthly':
                        return `${value} ${value > 1 ? 'Teachers' : 'Teacher'}`;
                    case 'totalLimitStudentsMonthly':
                        return `${value} ${value > 1 ? 'Students' : 'Student'}`;
                    case 'totalLimitStorageMonthly':
                        return `${value} GB storage`;
                    default:
                        return ''; // Optional: handle unexpected keys
                }
            } else {
                switch (key) {
                    case 'totalLimitStaffAnnualy':
                        return `${value} ${value > 1 ? 'Teachers' : 'Teacher'}`;
                    case 'totalLimitStudentsAnnualy':
                        return `${value} ${value > 1 ? 'Students' : 'Student'}`;
                    case 'totalLimitStorageAnnualy':
                        return `${value} GB storage`;
                    default:
                        return ''; // Optional: handle unexpected keys
                }
            }
        },
        buyPaddleProduct(price, product) {
            console.log('buyPaddleProduct: ')
            console.log('price: ', price)
            console.log('product: ', product)

            // move to signup page
            this.$router.push({ name: 'signup', params: { price_id: price.id }});
        }
    }
}
</script>
<style>
body .plan-info-wrapper {
  font-family: sans-serif !important;
}
</style>